module.exports = __webpack_public_path__ + "dash_20_app_assets/img/plan.f39d12b3.png";